import React from "react";
import { TwoRow } from "../../core/layouts";
import PlanOperationRepairAuditLayout from "../../layouts/PlanOperationRepairAuditLayout";
import variables from "../../themes/base/styles/variables";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";
import { Text } from "react_reusable_components";
import Style from "./PlanRepairOperationAuditContainer.module.scss";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import TentativeDateContainer from "../TentativeDateContainer";
import { planAuditFieldName } from "../../validationSchema/planAuditSchema";
import DnsdSelectContainer from "../DnsdSelectContainer";

export default function PlanRepairOperationAuditContainer({
  productSubProductList,
  dnsdList,
  tmList,
  values,
  errors,
  touched,
  setFieldValue,
  handleChange,
  setFieldTouched,
  validateField,
  setValues,
}) {
  const intl = useIntl();
  return (
    <TwoRow
      style={{ overflow: variables.unset }}
      topSection={
        <PlanOperationRepairAuditLayout
          leftSection={
            values[planAuditFieldName.AUDIT_TYPE] === "Repair" ? (
              <CustomSelect
                label={getLocalizedMessage(intl, "planAudit.subCategory.label")}
                required={true}
                placeholder={getLocalizedMessage(
                  intl,
                  "planAudit.subCategory.placeholder"
                )}
                showSearch={false}
                options={productSubProductList?.map?.(({ name, id }) => {
                  return {
                    label: (
                      <Text className={`${Style["select-item-style"]}`}>
                        {name}
                      </Text>
                    ),
                    value: id,
                  };
                })}
                name={planAuditFieldName.PRODUCT_SUB_CATEGORY_ID}
                value={values[planAuditFieldName.PRODUCT_SUB_CATEGORY_ID]}
                onChange={(e) =>
                  setValues((prev) => ({
                    ...prev,
                    [planAuditFieldName.PRODUCT_SUB_CATEGORY_ID]: e,
                    [planAuditFieldName.DNSD]: [],
                    [planAuditFieldName.DNSD_OBJ_ARR]: [],
                  }))
                }
                onBlur={() => {
                  setFieldTouched(
                    planAuditFieldName.PRODUCT_SUB_CATEGORY_ID,
                    true
                  );
                  validateField(planAuditFieldName.PRODUCT_SUB_CATEGORY_ID);
                }}
                error={
                  touched[planAuditFieldName.PRODUCT_SUB_CATEGORY_ID] &&
                  errors[planAuditFieldName.PRODUCT_SUB_CATEGORY_ID]
                }
              />
            ) : (
              <DnsdSelectContainer
                dnsdList={dnsdList}
                values={values}
                errors={errors}
                touched={touched}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                validateField={validateField}
                setValues={setValues}
              />
            )
          }
          middleSection={
            values[planAuditFieldName.AUDIT_TYPE] === "Repair" && (
              <DnsdSelectContainer
                dnsdList={dnsdList}
                values={values}
                errors={errors}
                touched={touched}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                validateField={validateField}
                setValues={setValues}
              />
            )
          }
        />
      }
      bottomSectionStyle={{
        display: "block",
        marginTop:
          values[planAuditFieldName.DNSD]?.length > 0
            ? variables.marginLarge
            : "",
      }}
      bottomSection={
        values[planAuditFieldName.DNSD]?.length > 0 && (
          <TentativeDateContainer
            dnsdList={dnsdList}
            values={values}
            errors={errors}
            touched={touched}
            setFieldValue={setFieldValue}
            handleChange={handleChange}
            tmList={tmList}
          />
        )
      }
    />
  );
}
